export const AccountMenuItems = {
  MENU_ITEM_1: "Change password",
  MENU_ITEM_2: "Contact Us",
  MENU_ITEM_3: "Releases",
  MENU_ITEM_4: "Logout",
};
